import api from './api';

const userService = {
  // Mettre à jour le profil utilisateur (avec ou sans photo)
  updateProfile: async (profileData, profilePhotoFile = null) => {
    try {
      let response;
      
      // Si une photo est fournie, utiliser FormData
      if (profilePhotoFile) {
        const formData = new FormData();
        formData.append('name', profileData.name || '');
        if (profileData.businessName !== undefined) {
          formData.append('businessName', profileData.businessName || '');
        }
        if (profileData.email !== undefined) {
          formData.append('email', profileData.email || '');
        }
        if (profileData.phone !== undefined) {
          formData.append('phone', profileData.phone || '');
        }
        formData.append('profilePhoto', profilePhotoFile);
        
        response = await api.put('/users/profile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        // Sinon, envoyer les données normalement
        response = await api.put('/users/profile', profileData);
      }
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du profil:', error);
      throw error;
    }
  },

  // Récupérer le profil utilisateur
  getProfile: async () => {
    try {
      const response = await api.get('/users/profile');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du profil:', error);
      throw error;
    }
  },

  // Changer la photo de profil
  updateProfilePhoto: async (photoData) => {
    try {
      const response = await api.put('/users/profile/photo', { profilePhoto: photoData });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la photo:', error);
      throw error;
    }
  }
};

export default userService;
